'use client';

import { useLocale } from 'next-intl';
import { useEffect } from 'react';
import { setAppLocale } from '@/lib/appLocale';
export default function HtmlLangUpdater() {
  const locale = useLocale();

  // Sync during render so signup/reset can read locale before effects run.
  setAppLocale(locale);
  useEffect(() => {
    document.documentElement.lang = locale;
    setAppLocale(locale);
  }, [locale]);
  return null;
}